import React, { useEffect, useRef, useState } from 'react'
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { setDateForTable, setInputDate } from '../../../utils/date';
import { formatNumberAmount, getSubscriberTimesheetStatusClass } from '../../../utils/general';
import Multiselect from 'multiselect-react-dropdown';
import { Button, Card, CardBody, CardHeader, Col, Container, DatePicker, FormInput, FormSelect, InputGroup, InputGroupAddon, InputGroupText, Row } from 'shards-react';
import ReactTable from 'react-table';
import { connect } from 'react-redux';
import { setAlert } from '../../../redux/actions/alert';
import { bulk_action_timesheet, bulk_action_timesheet_download, delete_bulk_timesheet, get_bulk_action_list, get_timesheet_list, get_timesheet_status_list, reset_timesheet_list } from '../../../redux/actions/subscriber/timesheet';
import { NavgationPageLocationKey, TimesheetSubscriberStatusList } from '../../../utils/constants';
import ConfirmAlert from '../../../components/common/ConfirmAlert';
import classNames from 'classnames';

const STATUS_ALL = 'All Statuses';
const TimesheetList = ({ timesheetSubStatusList, timesheetSubList
    , get_timesheet_list, get_timesheet_status_list, delete_bulk_timesheet
    , bulk_action_timesheet, bulk_action_timesheet_download
    , get_bulk_action_list, timesheetActionList
    , setAlert
}) => {
    const initialState = {
        pageSizeOptions: [5, 10, 15, 20, 25, 30],
        pageSize: 10,
        from: '',
        to: '',
        refNum: '',
        client: '',
        worker: '',
        status: '',
        bulkAction: '',
        projectName: '',
    }

    const defaultStatus = [];
    const [state, setState] = useState({ ...initialState });

    const [statusDropdownOptions, setStatusDropdownOptions] = useState([]);
    const [selectedValues, setSelectedValues] = useState([...defaultStatus]);

    const tableRef = useRef()
    const [tableData, setTableData] = useState([]);
    const history = useHistory();

    const [confirmAlert, setConfirmAlert] = useState({
        confirmMsg: "",
        visible: false,
        onConfirm: null
    });

    const onChange = (e) => {
        setState({ ...state, [e.target.name]: e.target.value });
    };

    const onCheck = (refNum) => {
        let checkedTableData = tableData.map(data => {
            if (data.refNum === refNum) {
                data.checked = !data.checked
            }

            return data;
        })

        setTableData(checkedTableData);
    }
    const checkAll = (e) => {
        let checkedTableData = tableData.map(data => {
            data.checked = e.target.checked;
            return data;
        })
        setTableData(checkedTableData);
    }
    const isAllChecked = () => {
        if (tableData.length === 0)
            return false

        for (let data of tableData) {
            if (!data.checked) {
                return false;
            }
        }
        return true;
    }

    const { pageSize, pageSizeOptions } = state;

    const deleteTimesheet = (timesheetRefList, isSingle) => {
        setConfirmAlert({
            confirmAlert,
            confirmMsg: 'Are you sure you want to delete timesheet(s)?',
            visible: true,
            onConfirm: async () => {
                await delete_bulk_timesheet({ refNumList: timesheetRefList });
                setConfirmAlert({
                    confirmAlert,
                    visible: false
                })
                get_timesheet_list(0, '', '', '', setInputDate(state.from), setInputDate(state.to), '');
                setState({ ...state, bulkAction: '' });
            }
        })
    }

    const actionPerformingTimesheet = (timesheetRefList, action, alertMessage) => {
        setConfirmAlert({
            confirmAlert,
            confirmMsg: alertMessage,
            visible: true,
            onConfirm: async () => {
                await bulk_action_timesheet({ refList: [...timesheetRefList], status: action });
                setConfirmAlert({
                    confirmAlert,
                    visible: false
                })
                get_timesheet_list(0, '', '', '', setInputDate(state.from), setInputDate(state.to), '');
                setState({ ...state, bulkAction: '' });
            }
        })
    }

    const tableColumns = [
        {
            Header: <input type="checkbox" checked={isAllChecked()} onClick={(e) => checkAll(e)} />,
            accessor: "action",
            maxWidth: 50, minWidth: 50,
            sortable: false,
            Cell: row => <input type="checkbox" checked={row.original.checked} key={row.original.refNum}
                onClick={() => onCheck(row.original.refNum)} />
        },
        {
            Header: "Timesheet #",
            accessor: "refNum",
            maxWidth: 130, minWidth: 130,
            Cell: row => <>
                <span className="p-0"><img src="./icons/edit-square.svg" height="17.5" width="17.5" className='icon-cursor mr-1' role="button"
                    onClick={(e) => { openTimesheetInNewTab(e, row.original.refNum) }}></img>
                </span>
                <a href="/add-edit-timesheet" onClick={(e) => { openTimesheetInNewTab(e, row.original.refNum) }}
                    onContextMenu={(e) => onContextMenuTimesheetChange(e, row.original.refNum)}>
                {row.original.timesheetRefNum}
            </a>
            </>
        },
        {
            Header: "Project",
            accessor: "projectName",
            minWidth: 100,
            classNames: 'text-center',
            Cell: row => <span className={row.original.projectName !== "" ? "w-100 text-left" : "w-100"}  title={row.original.projectName}>
                { row.original.projectName !== "" ? <span className="w-100 text-left" title={row.original.projectName}> {row.original.projectName} </span> : "--" }
            </span>
        },
        {
            Header: "Client",
            accessor: "client",
            minWidth: 100,
            classNames: 'text-left',
            Cell: row => <span className="w-100 text-left" title={row.original.client}>{row.original.client}</span>
        },
        {
            Header: "Worker",
            accessor: "worker",
            minWidth: 100,
            classNames: 'text-left',
            Cell: row => <span className="w-100 text-left" title={row.original.worker}>{row.original.worker}</span>
        },
        {
            Header: "Pay Period End Date",
            accessor: "payPeriodEndDate",
            maxWidth: 110, minWidth: 100,
            Cell: row => setDateForTable(row.original.payPeriodEndDate)
        },        
        {
            Header: "Regular Hours",
            accessor: "totalRegularHours",
            maxWidth: 100, minWidth: 100,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.totalRegularHours, 'en-US', 2, 2)}</span>
        },
        {
            Header: "Overtime Hours",
            accessor: "totalOvertimeHours",
            maxWidth: 150, minWidth: 100,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.totalOvertimeHours, 'en-US', 2, 2)}</span>
        },
        {
            Header: "PTO Hours",
            accessor: "totalPtoHours",
            maxWidth: 100, minWidth: 100,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.totalPtoHours, 'en-US', 2, 2)}</span>
        },
        {
            Header: "Total",
            accessor: "totalHours",
            maxWidth: 100, minWidth: 100,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.totalHours, 'en-US', 2, 2)}</span>
        },
        {
            Header: "Status",
            accessor: "status",
            maxWidth: 150, minWidth: 100,
            className: "text-center",
            Cell: row => <span className={getSubscriberTimesheetStatusClass(row.original.status)}>{row.original.status}</span>,
        },
        {
            Header: "",
            accessor: "action",
            maxWidth: 50, minWidth: 50,
            Cell: row =>
                <span className="p-1" role="button" onClick={() => {
                    deleteTimesheet([row.original.refNum], true);
                }}><img src="./icons/cross-icon.png" height="17.5" width="17.5" className='icon-cursor'/></span>
        }
    ]

    const reset = () => {
        setState({ ...initialState })
        setSelectedValues([...defaultStatus])
        //Need to change the objcect name
        get_timesheet_list(0, '', '', '', setInputDate(initialState.from), setInputDate(initialState.to), '');
    }

    const onSearch = (e) => {
        e.preventDefault()
        const selectedStatus = selectedValues.map(status => status.key).toLocaleString();
        let splitedRef = state.refNum.split('-');
        const refNum  = splitedRef.length > 1 ? splitedRef[1] : state.refNum;
        get_timesheet_list(refNum, state.client, state.worker, selectedStatus, setInputDate(state.from), setInputDate(state.to), state.projectName);
    }

    var bulkActionList = timesheetActionList?.map((item, i) => {
        return <option key={item + i} value={item}>{item}</option>
    })

    useEffect(() => {
        let timesheetStatus = timesheetSubStatusList.map(status => ({
            cat: status,
            key: status
        }))

        setStatusDropdownOptions([{
            cat: '',
            key: STATUS_ALL
        }, ...timesheetStatus])
    }, [timesheetSubStatusList])

    useEffect(() => {

        setTableData([...timesheetSubList])
    }, [timesheetSubList])

    const dangarAlert = () => {
        setAlert("Please select records to perform bulk action", 'danger');
        setState({ ...state, bulkAction: '' });
    }

    const unCheckAll = (e) => {
        let checkedTableData = tableData.map(data => {
            data.checked = false;
            return data;
        })
        setTableData(checkedTableData);
    }

    useEffect(() => {
        async function performAction() {
            if (state.bulkAction !== '') {
                if (tableData !== undefined && tableData.length > 0) {
                    var selectedData = tableData.filter(x => { return x.checked === true });
                    if (selectedData.length > 0) {
                        let refList = tableData.filter(data => data.checked).map(mapData => mapData.refNum);
                        let returnStatus = false;

                        if(state.bulkAction === "Approve")
                            actionPerformingTimesheet([...refList], TimesheetSubscriberStatusList.SubscriberApproved, "Are you sure you want to approve timesheet(s)");
                            //returnStatus = await bulk_action_timesheet({ refList: [...refList], status: TimesheetSubscriberStatusList.SubscriberApproved });
                        else if(state.bulkAction === "Reject")
                            actionPerformingTimesheet([...refList], TimesheetSubscriberStatusList.Rejected, "Are you sure you want to reject timesheet(s)");
                            //returnStatus = await bulk_action_timesheet({ refList: [...refList], status: TimesheetSubscriberStatusList.Rejected });
                        else if(state.bulkAction === "Delete"){
                            deleteTimesheet(refList, false);
                        }
                        else
                            returnStatus = await bulk_action_timesheet_download({ refNumList: [...refList], action: state.bulkAction });

                        if (returnStatus) {
                            unCheckAll();
                            setState({ ...state, bulkAction: '' });
                            get_timesheet_list(0, '', '', '', setInputDate(state.from), setInputDate(state.to), '');
                        }
                    }
                    else {
                        dangarAlert();
                    }
                }
                else {
                    dangarAlert();
                }
            }
        }
        performAction();
    }, [state.bulkAction])

    useEffect(() => {
        get_timesheet_list(0, '', '', '', setInputDate(state.from), setInputDate(state.to), '');
        get_timesheet_status_list();
        get_bulk_action_list();
    }, [])

    const navigateToAddTimesheet = (e) => {
        navigateToTimesheet(e, 0);
    }

    function navigateToTimesheet(e, refId){
        e.preventDefault(); 
        history.push({
            pathname: `/add-edit-timesheet`,
            state: { refNum: refId }
        });
        return false;
    }

    function onContextMenuTimesheetChange(e, refId){
        if(e.type === 'contextmenu'){
            localStorage.setItem(NavgationPageLocationKey.TimesheetCurrentAddEdit, refId);
        }
    }

    function openTimesheetInNewTab(e, refId) {
        e.preventDefault();
        localStorage.setItem(NavgationPageLocationKey.TimesheetCurrentAddEdit, refId);
        window.open('/add-edit-timesheet', '_blank');
    }

    return (
        <>
        <ConfirmAlert confirmAlert={confirmAlert} setConfirmAlert={setConfirmAlert}/>
        <Container fluid className="main-content-container px-4 pb-4">
            <div className="page-header tableSearch flex-column flex-md-row py-2 d-flex justify-content-end bg-white mt-4 ">

                <div className="d-flex align-items-center p-2">
                    <FormInput
                        name='refNum' value={state.refNum}
                        onChange={onChange} placeholder="Timesheet #"
                    />
                </div>

                <div className="d-flex align-items-center p-2">
                    <FormInput
                        name='projectName' value={state.projectName}
                        onChange={onChange} placeholder="Project"
                    />
                </div>

                <div className="d-flex align-items-center p-2">
                    <FormInput
                        name='client' value={state.client}
                        onChange={onChange} placeholder="Client"
                    />
                </div>

                <div className="d-flex align-items-center p-2">
                    <FormInput
                        name='worker' value={state.worker}
                        onChange={onChange} placeholder="Worker"
                    />
                </div>

                <div className="d-flex align-items-center p-2">
                    <Multiselect
                        hideSelectedList
                        displayValue="key"
                        placeholder={`Status: ${(selectedValues && selectedValues.length > 0 && selectedValues[0].key === STATUS_ALL) ? STATUS_ALL : selectedValues.map(val => val.key).toString()}`}
                        onKeyPressFn={function noRefCheck() { }}
                        onSearch={function noRefCheck() { }}
                        onRemove={function noRefCheck(selectedOptions, item) {
                            if (item.key === STATUS_ALL) {
                                setSelectedValues([])
                            } else {
                                selectedOptions = selectedOptions.filter(option => option.key !== STATUS_ALL)
                                setSelectedValues([...selectedOptions])
                            }
                        }}
                        onSelect={function noRefCheck(selectedOptions, seletedItem) {
                            if (seletedItem.key === STATUS_ALL) {
                                setSelectedValues([...statusDropdownOptions])
                            } else {
                                if (selectedOptions.length === statusDropdownOptions.length - 1) {
                                    selectedOptions = [...statusDropdownOptions]
                                }
                                setSelectedValues([...selectedOptions])
                            }

                        }}
                        options={[
                            ...statusDropdownOptions
                        ]}
                        selectedValues={[...selectedValues]}

                        showCheckbox />
                </div>

                <div className="d-flex align-items-center p-2">
                    <div className="d-flex align-items-center p-2">
                        <InputGroup className={classNames("d-flex", "my-auto", "date-range")}>
                            <DatePicker
                                name="from"
                                size="sm"
                                selected={state.from}
                                onChange={(date) => {
                                    setState({...state, from: date})
                                }}
                                dateFormat='yyyy-MM-dd'
                                placeholderText="From"
                                dropdownMode="select"
                                autoComplete='off'
                                className="text-center"
                            />
                            <DatePicker
                                name="to"
                                size="sm"
                                selected={state.to}
                                onChange={(date) => {
                                    setState({...state, to: date})
                                }}
                                dateFormat='yyyy-MM-dd'
                                placeholderText="To"
                                dropdownMode="select"
                                autoComplete='off'
                                className="text-center"
                                popperPlacement="top-end"
                            />
                            <InputGroupAddon type="append">
                                <InputGroupText>
                                    <i className="material-icons">&#xE916;</i>
                                </InputGroupText>
                            </InputGroupAddon>
                        </InputGroup>
                    </div>
                </div>

                <div className="d-flex align-items-center justify-content-end p-2">
                    <Button className="mx-2 py-2 my-2" size='sm' name="Search" theme="accent"
                        onClick={onSearch}>Search</Button>
                    <Button className="mx-2 py-2 my-2" size='sm' theme="accent" onClick={reset} >
                        Reset
                    </Button>
                </div>
            </div>

            <Card className="tableCard p-0">
                <CardHeader className="p-0">
                    <Container fluid className="file-manager__filters border-bottom">
                        <Row>
                            {/* Filters :: Page Size */}

                            <Col lg="2" className="file-manager__filters__rows d-flex justify-content-center justify-content-md-start align-items-center cl-2">
                                <span>
                                    <FormSelect size="sm" name='bulkAction' className="w-100"
                                        value={state.bulkAction} onChange={onChange}
                                    >
                                        <option key="bulkActions0" value="">Bulk Actions</option>
                                        { bulkActionList }
                                    </FormSelect>
                                </span>
                            </Col>
                            <Col lg="3" className="d-flex align-items-center">
                            </Col>
                            <Col lg="6" className="file-manager__filters__search d-flex justify-content-md-start col-7">
                                <Button className="mx-2 py-2 my-2" size='sm' theme="accent" onClick={navigateToAddTimesheet}>
                                    New Timesheet
                                </Button>
                            </Col>

                            <Col lg="1"
                                className="file-manager__filters__rows d-flex justify-content-center justify-content-md-end align-items-center col-2">
                                <span>Show</span>
                                <FormSelect
                                    size="sm"
                                    name='pageSize'
                                    value={state.pageSize}
                                    onChange={onChange}
                                >
                                    {pageSizeOptions.map((size, idx) => (
                                        <option key={idx} value={size}>
                                            {size} rows
                                        </option>
                                    ))}
                                </FormSelect>
                            </Col>
                        </Row>
                    </Container>
                </CardHeader>
                <CardBody className="p-0">
                    <div className="">
                        <ReactTable
                            columns={tableColumns}
                            data={tableData}
                            pageSize={Number(pageSize)}
                            showPageSizeOptions={false}
                            resizable={false}
                            noDataText="No results found"
                        />
                    </div>
                </CardBody>
            </Card>
        </Container>
        </>
    )
}
const mapStateToProps = (state) => ({
    timesheetSubList: state.timesheet.timesheetSubList,
    timesheetSubStatusList: state.timesheet.timesheetSubStatusList,
    timesheetActionList: state.timesheet.timesheetActionList,
})

export default connect(mapStateToProps, {
    get_timesheet_list,
    get_timesheet_status_list,
    delete_bulk_timesheet,
    bulk_action_timesheet,
    bulk_action_timesheet_download,
    reset_timesheet_list,
    get_bulk_action_list,
    setAlert,
})(TimesheetList)
